module.exports = __webpack_public_path__ + "img/2_user.65b27a56.svg";